import initContact from './components/contact';
import initHomeHeroHeight from './components/home-hero-height';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';

import initSmoothScroll from './components/smooth-scroll';
import initHeaderSticky from './components/header';
import initReferenceLightbox from './components/reference-lightbox';
import initServicesOffer from './components/services-offer';

document.documentElement.classList.add('has-js');

document.addEventListener('DOMContentLoaded', () => {
	initSmoothScroll();
	initHeaderSticky();
	initReferenceLightbox();
	initServicesOffer();
	initContact();
	initHomeHeroHeight();
});
